import axios from "axios";
import { baseUrl } from "../modules/account/login";
import { useContext } from "react";
import { AuthContext } from "../context/authContext";
import { useNavigate } from "react-router";
import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";

export function useConnectCalendar() {
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const navigate = useNavigate();

  const connectCalendar = async (type: "google" | "microsoft") => {
    try {
      const response = await axios.post(
        `${baseUrl}/calendar/${type}/auth_url`,
        {},
        { headers: { Authorization: AuthStr } }
      );
      if (response?.data?.data?.auth_url)
        window.open(response.data.data.auth_url, "_blank");
      return response.data;
    } catch (e: any) {
      if (e?.response?.data?.message === "Session expired") {
        navigate("/account/logout");
      }
      throw new Error(e?.message ?? "Check your internet connection");
    }
  };

  const { mutate, isPending, isSuccess, isError, error, data } = useMutation({
    mutationFn: connectCalendar,
  });

  return {
    connect: mutate,
    isLoading: isPending,
    isSuccess,
    isError,
    error,
    data: data?.data,
  };
}

export function useUserCalendar() {
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const navigate = useNavigate();

  const getUserCalendar = () => {
    return axios
      .get(`${baseUrl}/calendar/get_connected_calendars`, {
        headers: { Authorization: AuthStr },
      })
      .then((response) => {
        const data = response.data;
        return data;
      })
      .catch((e) => {
        if (e?.response?.data?.message === "Session expired")
          navigate("/account/logout");
        return Promise.reject(
          new Error(e?.message ?? "Check your internet connection")
        );
      });
  };
  const { isLoading, error, data } = useQuery({
    queryKey: ["user_calendars", token],
    queryFn: () => getUserCalendar(),
    placeholderData: keepPreviousData,
  });

  return { isLoading, error, data: data?.data };
}
